import { Star } from 'lucide-react';

export const StarRating = ({ rating = 0, size = 16, interactive = false, onChange, className = '' }) => {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={size}
          className={`${
            star <= rating
              ? 'fill-[#D4AF37] text-[#D4AF37]'
              : 'text-gray-300'
          } ${interactive ? 'cursor-pointer hover:text-[#D4AF37] transition-colors' : ''}`}
          onClick={interactive ? () => onChange?.(star) : undefined}
          data-testid={`star-${star}`}
        />
      ))}
    </div>
  );
};
